import Vue from 'vue';

class KlarnaService {
    constructor(config) {
        this.config = config;
        this.loaded = false;
        this.scriptElement = null;
        this.scriptSrc = 'https://x.klarnacdn.net/xs2a/app-launcher/v0/xs2a-app-launcher.js';
    }

    init() {
        return this.loadScript().then(() => {
            window.XS2A.configure(this.config);
        });
    }

    loadScript() {
        return new Promise((resolve, reject) => {
            this.scriptElement = document.createElement('script');
            document.body.appendChild(this.scriptElement);
            this.scriptElement.onload = resolve;
            this.scriptElement.onerror = reject;
            this.scriptElement.src = this.scriptSrc;
        });
    }

    startFlow(clientToken, config) {
        return window.XS2A.startFlow(clientToken, config);
    }
}

export default KlarnaService;
